import React from "react";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaClock,
  FaDumbbell,
} from "react-icons/fa";

function StatCard({ icon: Icon, label, value, description }) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-emerald-700 shadow-sm dark:bg-white/10 dark:text-emerald-200">
          <Icon />
        </div>

        <div>
          <p className="text-2xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>

          <p className="text-sm font-bold text-slate-700 dark:text-white/80">
            {label}
          </p>

          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function AdherentPrepaStats({ stats }) {
  return (
    <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        icon={FaDumbbell}
        label="Exercices"
        value={stats.total}
        description="Attribués par le coach"
      />

      <StatCard
        icon={FaClock}
        label="À réaliser"
        value={stats.pending}
        description="Exercices en attente"
      />

      <StatCard
        icon={FaCheckCircle}
        label="Progression"
        value={`${stats.percent}%`}
        description="Exercices validés"
      />

      <StatCard
        icon={FaCalendarAlt}
        label="Prochain exercice"
        value={stats.nextExerciseName}
        description={stats.nextExerciseDate}
      />
    </div>
  );
}

export default AdherentPrepaStats;